<div class="banner" role="alert">
  <div class="banner-text">
    <strong>{{ heading() }}</strong>
    <span>{{ message() }}</span>
    @if (note()) {
      <span class="banner-note">{{ note() }}</span>
    }
  </div>
  <button type="button" class="retry" (click)="retry.emit()" [disabled]="busy()">
    {{ busy() ? 'Trying…' : 'Try again' }}
  </button>
</div>
